import React from 'react';

import IDevolutionTicketGridProps from './interface';
import IDevolutionTicketForDropdown, { IDevolutionOrderForDropdown } from 'models/Ticket/Devolution/IDevolutionTicketForDropdown';

import { Column, Row } from 'components/Layout/Grid';
import DevolutionInvoicePdfDownloadButton from '../DevolutionInvoicePdfDownloadButton';
import DevolutionInvoiceXmlDownloadButton from '../DevolutionInvoiceXmlDownloadButton';
import ProtocolButton from 'components/Pipefy/ProtocolNumber';
import Text from 'components/Text';

import * as Styled from "./styles";

const DevolutionTicketGrid: React.FC<IDevolutionTicketGridProps> = (props) => {
    const { data, showDevolutionDownloadButtons } = props;

    const getRowBackgroundColor = (index: number) => (index % 2 !== 0 ? 'bg-gray-light' : 'bg-gray-10');

    const renderDownloadButtonSection = (order: IDevolutionOrderForDropdown) => {
        return (
            <Row>
                <DevolutionInvoicePdfDownloadButton order={order} className="h-100" />
                <DevolutionInvoiceXmlDownloadButton order={order} className="ml-2 h-100" />
            </Row>
        );
    };

    const renderItem = (item: IDevolutionTicketForDropdown, index: number) => {
        return (
            <Styled.DevolutionTicketGridRow className={`${getRowBackgroundColor(index)}`}>
                <Column className='w-100 justify-center flex-1'>
                    <Row className='align-center'>
                        <Styled.LabelText >Protocolo:</Styled.LabelText>
                        <ProtocolButton data={item} />
                    </Row>
                </Column>
                <Column className='w-100 justify-center'>
                    <Row>
                        <Styled.LabelText>Status:</Styled.LabelText>
                        <Styled.ContentText>{item.phaseStatus}</Styled.ContentText>
                    </Row>
                </Column>
                {showDevolutionDownloadButtons
                    && item.order.isInvoiceDownloadEnabled
                    && renderDownloadButtonSection(item.order)
                }
            </Styled.DevolutionTicketGridRow>
        );
    };

    return (
        <>
            <Row className='mt-3 mb-2'>
                <Text className="text-styles d-block font-bold color-blue-gray">
                    Outros Protocolos
                </Text>
            </Row>
            <div className='mb-4'>
                {data.map((item, index) => renderItem(item, index))}
            </div>
        </>
    );
};

export default DevolutionTicketGrid;